import { isRouteErrorResponse, useRouteError } from 'react-router';
import { ButtonLink } from '../ui/Button';

export function RouteError({ notFound = false }: { notFound?: boolean; embedded?: boolean }) {
  const error = useRouteError();
  const is404 = notFound || (isRouteErrorResponse(error) && error.status === 404);
  if (!is404) console.error(error);
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center px-4 text-center">
      <p className="font-mono text-sm text-brand-700">{is404 ? '404' : 'Error'}</p>
      <h1 className="mt-2 text-2xl font-semibold">
        {is404 ? 'This page took a wrong turn' : 'Something went wrong'}
      </h1>
      <p className="mt-2 max-w-md text-sm text-ink-500">
        {is404
          ? "We couldn't find the page you were looking for."
          : 'An unexpected error stopped this page from loading. Reloading usually fixes it.'}
      </p>
      <ButtonLink to="/" className="mt-6">
        Go to dashboard
      </ButtonLink>
    </main>
  );
}
